import ItemCategoryApi from '@apis/item/ItemCategoryApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const categoryQueries = createQueryKeys('category', {
    list: (shopId: string) => ({
        queryKey: [shopId],
        queryFn: () => ItemCategoryApi.getItemCategories(shopId),
    }),
});

export default categoryQueries;
